import { Box, Chip, Stack, Typography } from '@mui/material';

export type EmailPreviewData = {
  from: string;
  to: string;
  cc?: string;
  bcc?: string;
  subject: string;
  textPreview?: string;
  unlinkedEmails?: string[];
};

const splitAddresses = (addresses?: string) =>
  (addresses ?? '')
    .split(',')
    .map((address) => address.trim())
    .filter(Boolean);

const AddressRows = ({ label, addresses, unlinkedEmails }: { label: string; addresses: string[]; unlinkedEmails: Set<string> }) => {
  if (!addresses.length) return null;

  return (
    <Stack direction="row" alignItems="flex-start" spacing={1}>
      <Typography component="span" fontWeight={700} sx={{ minWidth: 48 }}>
        {label}:
      </Typography>
      <Stack>
        {addresses.map((address, index) => {
          const isUnlinked = unlinkedEmails.has(address.toLowerCase());
          return (
            <Stack direction="row" alignItems="center" spacing={1} key={`${address}-${index}`}>
              <Typography component="span" color={isUnlinked ? 'error.main' : 'inherit'} sx={{ wordBreak: 'break-word' }}>
                {address}
              </Typography>
              {isUnlinked && <Chip label="Не в контактах" color="error" variant="outlined" size="small" />}
            </Stack>
          );
        })}
      </Stack>
    </Stack>
  );
};

export const EmailPreview = ({ data, linkedEmails = [] }: { data: EmailPreviewData; linkedEmails?: string[] }) => {
  const unlinkedEmails = new Set((data.unlinkedEmails ?? []).map((email) => email.trim().toLowerCase()));
  linkedEmails.forEach((email) => unlinkedEmails.delete(email.trim().toLowerCase()));

  return (
    <Box>
      <AddressRows label="FROM" addresses={splitAddresses(data.from)} unlinkedEmails={unlinkedEmails} />
      <AddressRows label="TO" addresses={splitAddresses(data.to)} unlinkedEmails={unlinkedEmails} />
      <AddressRows label="CC" addresses={splitAddresses(data.cc)} unlinkedEmails={unlinkedEmails} />
      <AddressRows label="BCC" addresses={splitAddresses(data.bcc)} unlinkedEmails={unlinkedEmails} />
      <Typography mt={1}>
        Тема: <b>{data.subject}</b>
      </Typography>
      {data.textPreview && <Typography mt={1}>{data.textPreview}</Typography>}
    </Box>
  );
};
